import React from "react";
import { Card } from "react-bootstrap";

export default function ButtonBar({ children }) {

    return (
        <Card className="bg-light mb-4">
            <Card.Body className="p-2 d-flex align-items-center" style={{ gap: "0.4rem"}}>
                {children}
            </Card.Body>
        </Card>
    )
}